import React from 'react';
import { transferLimitFields } from '../utils/transferLimits';

const display = (value, unit) => {
  if (value === null) return '—';
  if (unit === 'money') return Number(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  return `${Number(value).toLocaleString('en-US')} ${Number(value) === 1 ? unit.slice(0, -1) : unit}`;
};

export default function TransferLimitsModal({ modal, canEdit, canViewCollectionReport, onClose, onSave, onAdjust, onChange }) {
  const violatedKeys = new Set(modal.entries.filter((entry) => entry.violated).map((entry) => entry.key));
  return (
    <div className="transfer-alert-overlay transfer-limits-overlay">
      <form className="transfer-limits-modal" role="dialog" aria-modal="true" aria-labelledby="transfer-limits-title" onSubmit={onSave}>
        <h3 id="transfer-limits-title">{modal.editing ? 'Adjust Customer Limits' : 'Customer Limits Exceeded'}</h3>
        <div className="transfer-limits-customer-row">
          <p><strong>{modal.customer.name || modal.customer.companyname}</strong> (#{modal.customer.id})</p>
          {canViewCollectionReport && (
            <button type="button" className="button small blue"
              onClick={() => window.open(`/customers?customerId=${encodeURIComponent(modal.customer.id)}&tab=collectionReport`, '_blank', 'noopener,noreferrer')}>
              Collection Report
            </button>
          )}
        </div>
        <p>Current stock and age are shown for the destination. Highlighted limits are exceeded when the pending transfer is included.</p>
        <div className="transfer-limits-table-wrap">
          <table>
            <thead><tr><th>Limit</th><th>Current stock / age</th><th>Saved limit</th><th>Status</th></tr></thead>
            <tbody>{modal.entries.map((entry, index) => (
              <tr key={`${entry.key}-${index}`} className={entry.violated ? 'limit-exceeded' : ''}>
                <th scope="row">{entry.label}{entry.itemName && <small>{entry.itemName}</small>}</th>
                <td>{display(entry.current, entry.unit)}</td>
                <td>{entry.limit === null ? 'No limit' : display(entry.limit, entry.unit)}</td>
                <td><strong>{entry.violated ? 'Exceeded' : 'Within limit'}</strong></td>
              </tr>
            ))}</tbody>
          </table>
        </div>
        {modal.editing && (
          <>
            <p>These changes update the customer’s Profile. Blank or 0 means no limit. Inventory age is the age of the oldest current stock.</p>
            <div className="transfer-limits-fields">
              {transferLimitFields.map(({ key, label, step }) => (
                <label key={key} className={violatedKeys.has(key) ? 'limit-field-exceeded' : ''}>
                  <span>{label}{violatedKeys.has(key) && <strong> — exceeded</strong>}</span>
                  <input type="number" min="0" step={step} value={modal.draft[key]} disabled={modal.saving}
                    onChange={(event) => onChange(key, event.target.value)} />
                </label>
              ))}
            </div>
          </>
        )}
        {!canEdit && <p>You do not have permission to edit this customer’s limits.</p>}
        {modal.error && <p className="transfer-confirm-error" role="alert">{modal.error}</p>}
        <div className="transfer-confirm-actions">
          <button type="button" className="button small yellow" onClick={onClose} disabled={modal.saving}>{modal.editing ? 'Cancel' : 'OK'}</button>
          {canEdit && (modal.editing
            ? <button type="submit" className="button small blue" disabled={modal.saving}>{modal.saving ? 'Saving...' : 'Save Limits'}</button>
            : <button type="button" className="button small blue" onClick={onAdjust}>Adjust Limits</button>)}
        </div>
      </form>
    </div>
  );
}
